export enum BREAK_POINT {
  DEFAULT = 0,
  XS = 375,
  SM = 480,
  MD = 768,
  LG = 1014,
  XL = 1336,
}
